import { render, staticRenderFns } from "./jxsposdownload.vue?vue&type=template&id=75f4d003"
import script from "./jxsposdownload.vue?vue&type=script&lang=js"
export * from "./jxsposdownload.vue?vue&type=script&lang=js"
import style0 from "./jxsposdownload.vue?vue&type=style&index=0&id=75f4d003&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports